import { HubConnectionState } from '@microsoft/signalr';
import { TFunction } from 'i18next';

type GetConnectionStateTextProps = {
  connectionState: HubConnectionState;
  siteName: string;
  t: TFunction;
};

export const getConnectionStateText = ({
  connectionState,
  siteName,
  t,
}: GetConnectionStateTextProps): string => {
  switch (connectionState) {
    case HubConnectionState.Connected:
      return t('hubConnection.connectedToSite', { siteName });
    case HubConnectionState.Connecting:
      return t('hubConnection.connectingToSite', { siteName });
    case HubConnectionState.Reconnecting:
      return t('hubConnection.reconnectingToSite', { siteName });
    case HubConnectionState.Disconnecting:
      return t('hubConnection.disconnectingFromSite', { siteName });
    case HubConnectionState.Disconnected:
      return t('hubConnection.disconnectedFromSite', { siteName });
    default:
      return String(connectionState);
  }
};
